exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redColoredText[data-v-fc18299e]{color:red}", ""]);

// exports
